// Typed client for GET /api/v1/workspaces and /api/v1/workspaces/{slug} (ROADMAP.md v0.6.2).
// Replaces pages/HomePage/workspaces.ts's hardcoded WORKSPACES constant — adding or renaming a
// workspace is now a platform_db data change, not a frontend deploy (v0.6.2's acceptance
// criterion). Goes through apiFetch, not a bare fetch(), to inherit the one-time outpost
// forward-auth handshake (see api/platformApi.ts).

import { apiFetch } from './platformApi';

export interface WorkspaceSummary {
  workspace_id: string;
  slug: string;
  title: string;
  description: string | null;
  icon: string | null;
  sort_order: number;
  empty: boolean;
  empty_message: string | null;
}

export interface WorkspaceLayerBinding {
  dataset_id: string | null;
  geoserver_layer_name: string | null;
  scene_group: string | null;
  scene_folder: string | null;
  default_visible: boolean;
  sort_order: number;
}

export interface WorkspaceDetail extends WorkspaceSummary {
  layers: WorkspaceLayerBinding[];
}

/** Fetches the caller's visible workspaces, in display order. Throws on any non-200 (including
 * 401, which normally never reaches here — apiFetch handles it) or a malformed body; the caller
 * decides how to render that as an honest error state (HomePage's loading/error/ready machine). */
export async function fetchWorkspaces(): Promise<WorkspaceSummary[]> {
  const res = await apiFetch('/api/v1/workspaces');
  if (!res.ok) throw new Error(`GET /api/v1/workspaces -> ${res.status}`);
  const body: unknown = await res.json();
  if (!Array.isArray(body)) throw new Error('GET /api/v1/workspaces: expected a JSON array');
  return body as WorkspaceSummary[];
}
